var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"base-avatar",class:_setup.baseAvatarClasses},_vm.$listeners),[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"width":"36","height":"36","loading":"lazy","alt":"Avatar"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }